import ProductCategoryCard from './ProductCategoryCard'

export default ProductCategoryCard
